import React from "react";
import "./page.css";
import {
  TextField,
  Slider,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Divider,
} from "@material-ui/core";

import InputFamily from "../components/InputFamily";
import DisabledFamily from "../components/DisabledFamily";
import Tutrial from "../components/Tutrial";
import TutrialImage1 from "../asset/tutrial/dec/tutrial1.gif";
import TutrialImage2 from "../asset/tutrial/dec/tutrial2.jpg";

import {
  NumberFormatCustomHundred,
  NumberFormatCustom,
} from "../components/NumberFormatCustom.js";
import handleUpdate from "../functions/handleUpdate";
import { connect } from "react-redux";
import {
  changeSougaku,
  changeHaiguusha,
  changeChild,
  changeKazeiIsangaku1,
  changeKazeiIsangaku2,
  changeKazeiIsangaku3,
} from "../actions/actions";
import { calculate } from "../functions/CalculateSouzoku.js";
import firebase from "../firebase";

import CanvasJSReact from "../asset/canvasjs.react";
//var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

function Niji(props) {
  const sougaku = props.sougaku;
  const child = props.child;
  return (
    <div className="listContainer">
      <div className="listTitle">二次相続</div>
      <TableContainer>
        <Table>
          <TableBody>
            {calculate(Number(sougaku) / 2, 0, child)[0].map((l, i) => (
              <TableRow key={i}>
                <TableCell component="th" scope="row">
                  {l.name}
                </TableCell>
                <TableCell align="right">{l.value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

function NijiG(props) {
  const sougaku = props.sougaku;
  const child = props.child;
  const genshouGaku = props.genshouGaku;
  const genshouKikan = props.genshouKikan;
  return (
    <div className="listContainer">
      <div className="listTitle">二次相続(減少後)</div>
      <TableContainer>
        <Table>
          <TableBody>
            {calculate(
              (Number(sougaku) - Number(genshouGaku * genshouKikan) / 100) / 2,
              0,
              child
            )[0].map((l, i) => (
              <TableRow key={i}>
                <TableCell component="th" scope="row">
                  {l.name}
                </TableCell>
                <TableCell align="right">{l.value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

class Decrease extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gKazeiIsangaku1: 0,
      gKazeiIsangaku2: 0,
      gKazeiIsangaku3: 0,
      genshouGaku: "",
      genshouKikan: 10,
      calculationCount: 0,
      tutrial: false
    };
  }

  data1() {
    return calculate(
      this.props.sougaku,
      this.props.haiguusha,
      this.props.child
    )[1];
  }

  data2() {
    return calculate(Number(this.props.sougaku) / 2, 0, this.props.child)[1];
  }

  gData1() {
    let genshou;
    if (
      Number(this.state.genshouGaku) === 0 &&
      Number(this.state.genshouKikan) === 0
    ) {
      genshou = 0;
    } else {
      genshou =
        Number(this.state.genshouGaku) * Number(this.state.genshouKikan);
    }
    return calculate(
      Number(this.props.sougaku) - genshou / 100,
      this.props.haiguusha,
      this.props.child
    )[1];
  }

  gData2() {
    let genshou;
    if (
      Number(this.state.genshouGaku) === 0 &&
      Number(this.state.genshouKikan) === 0
    ) {
      genshou = 0;
    } else {
      genshou =
        Number(this.state.genshouGaku) * Number(this.state.genshouKikan);
    }
    return calculate(
      (Number(this.props.sougaku) - genshou / 100) / 2,
      0,
      this.props.child
    )[1];
  }

  chartError() {
    alert("グラフ読み込みエラー");
  }

  componentDidMount() {
    this.props.changeKazeiIsangaku1(this.data1()[0]);
    this.props.changeKazeiIsangaku2(this.data1()[1]);
    this.props.changeKazeiIsangaku3(this.data2()[1]);
    this.setState({ gKazeiIsangaku1: this.gData1()[0] });
    this.setState({ gKazeiIsangaku2: this.gData1()[1] });
    this.setState({ gKazeiIsangaku3: this.gData2()[1] });
    const ended = localStorage.getItem("tutrial3");
    // console.log("ended: ", ended);
    if (ended) {
      this.setState({ tutrial: false });
    } else {
      this.setState({ tutrial: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    handleUpdate();

    const analytics = firebase.analytics();
    if (
      prevProps.sougaku !== this.props.sougaku ||
      prevProps.haiguusha !== this.props.haiguusha ||
      prevProps.child !== this.props.child ||
      prevState.genshouGaku !== this.state.genshouGaku ||
      prevState.genshouKikan !== this.state.genshouKikan
    ) {
      this.props.changeKazeiIsangaku1(this.data1()[0]);
      this.props.changeKazeiIsangaku2(this.data1()[1]);
      this.props.changeKazeiIsangaku3(this.data2()[1]);
      this.setState({ gKazeiIsangaku1: this.gData1()[0] });
      this.setState({ gKazeiIsangaku2: this.gData1()[1] });
      this.setState({ gKazeiIsangaku3: this.gData2()[1] });
      analytics.logEvent("calculation");
      this.setState({ calculationCount: this.state.calculationCount + 1 });
      if (this.state.calculationCount % 10 === 0) {
        analytics.logEvent("calculate10times");
      }
    }
  }

  closeTutrial = () => {
    localStorage.setItem("tutrial3", "ended");
    this.setState({ tutrial: false })
  };

  render() {
    const indexLabel1 = this.props.KazeiIsangaku1 === 0 ? "white" : "black";
    const indexLabel2 = this.props.KazeiIsangaku2 === 0 ? "white" : "black";
    const indexLabel3 = this.props.KazeiIsangaku3 === 0 ? "white" : "black";
    const data = [
      {
        x: 0,
        y: 10,
      },
      {
        x: 1000,
        y: 15,
      },
      {
        x: 3000,
        y: 20,
      },
      {
        x: 5000,
        y: 30,
      },
      {
        x: 10000,
        y: 40,
      },
      {
        x: 20000,
        y: 45,
      },
      {
        x: 30000,
        y: 50,
      },
      {
        x: 60000,
        y: 55,
      },
      {
        x: 600000000,
        y: 55,
      },
    ];

    const option1 = {
      animationEnabled: false,
      backgroundColor: "#ffffff",
      title: {
        text: "一次相続税",
        fontFamily: "arial",
        fontSize: 18,
        padding: 10,
      },
      subtitles: [
        {
          text: `対策前:  配偶者の課税遺産額 ${this.props.KazeiIsangaku1}万円`,
          fontFamily: "arial",
          fontSize: 14,
          padding: 3,
        },
        {
          text: `対策後:  配偶者の課税遺産額 ${this.state.gKazeiIsangaku1}万円`,
          fontFamily: "arial",
          fontSize: 14,
          padding: 3,
        },
        {
          text: `対策による相続税の減少効果  ${
            this.data1()[2] - this.gData1()[2]
          }万円`,
          fontFamily: "arial",
          fontSize: 14,
          padding: 3,
        },
      ],
      axisX: {
        suffix: "万円",
        minimum: 0,
        maximum: Number(this.props.KazeiIsangaku1),
        tickLength: 5,
        tickThickness: 2,
      },
      axisY: {
        title: "税率",
        maximum: 100,
        suffix: "%",
      },
      toolTip: {
        enabled: true,
        animationEnabled: true,
        fontSize: 12,
      },
      data: [
        {
          type: "area",
          fillOpacity: 0.5,
          name: "課税遺産額",
          markerBorderColor: "white",
          markerBorderThickness: 2,
          showInLegend: true,
          yValueFormatString: '#,##0.##"%"',
          dataPoints: [
            {
              x: 0,
              y: 100,
            },
            {
              x: this.props.KazeiIsangaku1,
              y: 100,
            },
          ],
        },
        {
          type: "stepArea",
          fillOpacity: 0.7,
          color: "#F2A2B8",
          indexLabel: "{y}",
          indexLabelFontColor: indexLabel1,
          markerSize: 5,
          yValueFormatString: '#,##0.##"%"',
          dataPoints: data,
        },
        {
          type: "area",
          fillOpacity: 0.5,
          name: "減少後課税遺産額",
          color: "#62A718",
          markerBorderColor: "white",
          markerBorderThickness: 2,
          showInLegend: true,
          yValueFormatString: '#,##0.##"%"',
          dataPoints: [
            {
              x: 0,
              y: 100,
            },
            {
              x: this.state.gKazeiIsangaku1,
              y: 100,
            },
          ],
        },
      ],
    };

    const option2 = {
      animationEnabled: false,
      backgroundColor: "#ffffff",
      title: {
        text: this.props.haiguusha === 1 ? "一次相続税" : "二次相続税",
        fontFamily: "arial",
        fontSize: 18,
        padding: 10,
      },
      subtitles: [
        {
          text: `対策前:  子供の課税遺産額 ${this.props.KazeiIsangaku2}万円`,
          fontFamily: "arial",
          fontSize: 14,
          padding: 3,
        },
        {
          text: `対策後:  子供の課税遺産額 ${new Intl.NumberFormat().format(
            this.state.gKazeiIsangaku2
          )}万円`,
          fontFamily: "arial",
          fontSize: 14,
          padding: 3,
        },
        {
          text: `対策による相続税の減少効果  ${new Intl.NumberFormat().format(
            this.data1()[2] - this.gData1()[2]
          )}万円`,
          fontFamily: "arial",
          fontSize: 14,
          padding: 3,
        },
      ],
      axisX: {
        suffix: "万円",
        minimum: 0,
        maximum: Number(this.props.KazeiIsangaku2),
        tickLength: 5,
        tickThickness: 2,
      },
      axisY: {
        title: "税率",
        maximum: 100,
        suffix: "%",
      },
      toolTip: {
        enabled: true,
        animationEnabled: true,
        fontSize: 12,
      },
      data: [
        {
          type: "area",
          fillOpacity: 0.5,
          name: "課税遺産額",
          markerBorderColor: "white",
          markerBorderThickness: 2,
          showInLegend: true,
          yValueFormatString: '#,##0.##"%"',
          dataPoints: [
            {
              x: 0,
              y: 100,
            },
            {
              x: this.props.KazeiIsangaku2,
              y: 100,
            },
          ],
        },
        {
          type: "stepArea",
          fillOpacity: 0.7,
          color: "#F2A2B8",
          indexLabel: "{y}",
          indexLabelFontColor: indexLabel2,
          markerSize: 5,
          yValueFormatString: '#,##0.##"%"',
          dataPoints: data,
        },
        {
          type: "area",
          fillOpacity: 0.5,
          name: "減少後課税遺産額",
          color: "#62A718",
          markerBorderColor: "white",
          markerBorderThickness: 2,
          showInLegend: true,
          yValueFormatString: '#,##0.##"%"',
          dataPoints: [
            {
              x: 0,
              y: 100,
            },
            {
              x: this.state.gKazeiIsangaku2,
              y: 100,
            },
          ],
        },
      ],
    };

    const option3 = {
      animationEnabled: false,
      backgroundColor: "#ffffff",
      title: {
        text: "二次相続税",
        fontFamily: "arial",
        fontSize: 18,
        padding: 10,
      },
      subtitles: [
        {
          text: `対策前:  子供の課税遺産額 ${new Intl.NumberFormat().format(
            this.props.KazeiIsangaku3
          )}万円`,
          fontFamily: "arial",
          fontSize: 14,
          padding: 3,
        },
        {
          text: `対策後:  子供の課税遺産額 ${new Intl.NumberFormat().format(
            this.state.gKazeiIsangaku3
          )}万円`,
          fontFamily: "arial",
          fontSize: 14,
          padding: 3,
        },
        {
          text: `対策による相続税の減少効果  ${new Intl.NumberFormat().format(
            this.data2()[2] - this.gData2()[2]
          )}万円`,
          fontFamily: "arial",
          fontSize: 14,
          padding: 3,
        },
      ],
      axisX: {
        suffix: "万円",
        minimum: 0,
        maximum: Number(this.props.KazeiIsangaku3),
        tickLength: 5,
        tickThickness: 2,
      },
      axisY: {
        title: "税率",
        maximum: 100,
        suffix: "%",
      },
      toolTip: {
        enabled: true,
        animationEnabled: true,
        fontSize: 12,
      },
      data: [
        {
          type: "area",
          fillOpacity: 0.5,
          name: "課税遺産額",
          markerBorderColor: "white",
          markerBorderThickness: 2,
          showInLegend: true,
          yValueFormatString: '#,##0.##"%"',
          dataPoints: [
            {
              x: 0,
              y: 100,
            },
            {
              x: this.props.KazeiIsangaku3,
              y: 100,
            },
          ],
        },
        {
          type: "stepArea",
          fillOpacity: 0.7,
          color: "#F2A2B8",
          indexLabel: "{y}",
          indexLabelFontColor: indexLabel3,
          markerSize: 5,
          yValueFormatString: '#,##0.##"%"',
          dataPoints: data,
        },
        {
          type: "area",
          fillOpacity: 0.5,
          name: "減少後課税遺産額",
          color: "#62A718",
          markerBorderColor: "white",
          markerBorderThickness: 2,
          showInLegend: true,
          yValueFormatString: '#,##0.##"%"',
          dataPoints: [
            {
              x: 0,
              y: 100,
            },
            {
              x: this.state.gKazeiIsangaku3,
              y: 100,
            },
          ],
        },
      ],
    };

    return (
      <div>
      {this.state.tutrial ? <Tutrial closeTutrial={this.closeTutrial} image1={TutrialImage1} image2={TutrialImage2} /> :
      <div className="container">
        <section className="userArea">
          <TextField
            label="課税遺産額"
            onChange={(event) => this.props.changeSougaku(event.target.value)}
            value={`${this.props.sougaku}`}
            InputProps={{
              inputComponent: NumberFormatCustomHundred,
              type: "tel",
            }}
            fullWidth={true}
            color={"secondary"}
          />
          {this.props.isPaid && !this.props.needEmailVerify ? (
            <InputFamily
              haiguusha={this.props.haiguusha}
              changeHaiguusha={this.props.changeHaiguusha}
              child={this.props.child}
              changeChild={this.props.changeChild}
            />
          ) : (
            <DisabledFamily
              haiguusha={this.props.haiguusha}
              child={this.props.child}
            />
          )}
        </section>
        <Divider style={{ backgroundColor: "#cfd8dc" }} />
        <section className="userArea">
          <TextField
            label="財産減少額 (年間)"
            onChange={(event) =>
              this.setState({ genshouGaku: event.target.value })
            }
            value={`${this.state.genshouGaku}`}
            InputProps={{
              inputComponent: NumberFormatCustom,
              type: "tel",
            }}
            fullWidth={true}
            color={"secondary"}
          />
          <div style={{ height: 50, marginTop: 20 }}>
            <div>
              <span style={{ color: "#006699", fontWeight: "bold" }}>
                減少期間
              </span>
              : {this.state.genshouKikan} 年
            </div>
            <Slider
              value={this.state.genshouKikan}
              max={30}
              min={1}
              step={1}
              onChange={(event, newValue) =>
                this.setState({ genshouKikan: newValue })
              }
              color={"secondary"}
            />
          </div>
        </section>
        <Divider style={{ backgroundColor: "#cfd8dc" }} />
        <section className="resultArea">
          <div className="listContainer">
            <div className="listTitle">{`${
              this.props.haiguusha === 1 ? "一次" : "二次"
            }相続`}</div>
            <TableContainer>
              <Table>
                <TableBody>
                  {calculate(
                    this.props.sougaku,
                    this.props.haiguusha,
                    this.props.child
                  )[0].map((l, i) => (
                    <TableRow key={i}>
                      <TableCell component="th" scope="row">
                        {l.name}
                      </TableCell>
                      <TableCell align="right">{l.value}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          {this.props.haiguusha === 1 && (
            <Niji sougaku={this.props.sougaku} child={this.props.child}></Niji>
          )}
          <div className="listContainer">
            <div className="listTitle">{`${
              this.props.haiguusha === 1 ? "一次" : "二次"
            }相続 (減少後)`}</div>
            <TableContainer>
              <Table>
                <TableBody>
                  {calculate(
                    Number(this.props.sougaku) -
                      (Number(this.state.genshouGaku) *
                        Number(this.state.genshouKikan)) /
                        100,
                    this.props.haiguusha,
                    this.props.child
                  )[0].map((l, i) => (
                    <TableRow key={i}>
                      <TableCell component="th" scope="row">
                        {l.name}
                      </TableCell>
                      <TableCell align="right">{l.value}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          {this.props.haiguusha === 1 && (
            <NijiG
              sougaku={this.props.sougaku}
              child={this.props.child}
              genshouGaku={this.state.genshouGaku}
              genshouKikan={this.state.genshouKikan}
            ></NijiG>
          )}
          {/* chart1 */}
          {this.props.haiguusha === 1 && (
            <div>
              <div className="chartContainer">
                <CanvasJSChart options={option1} />
              </div>
            </div>
          )}
          {/* chart2 */}
          <div>
            <div className="chartContainer">
              <CanvasJSChart options={option2} />
            </div>
          </div>
          {/* chart3 */}
          {this.props.haiguusha === 1 && (
            <div>
              <div className="chartContainer">
                <CanvasJSChart options={option3} />
              </div>
            </div>
          )}
        </section>
      </div>}</div>
    );
  }
}

const mapStateToProps = (state) => ({
  sougaku: state.user.sougaku,
  haiguusha: state.user.haiguusha,
  child: state.user.child,
  KazeiIsangaku1: state.user.KazeiIsangaku1,
  KazeiIsangaku2: state.user.KazeiIsangaku2,
  KazeiIsangaku3: state.user.KazeiIsangaku3,
  isPaid: state.user.isPaid,
  needEmailVerify: state.user.needEmailVerify
});

const mapDispatchToProps = {
  changeSougaku,
  changeHaiguusha,
  changeChild,
  changeKazeiIsangaku1,
  changeKazeiIsangaku2,
  changeKazeiIsangaku3,
};

export default connect(mapStateToProps, mapDispatchToProps)(Decrease);
